export default "__VITE_ASSET__BPuPO$B1__"